import React from 'react';
import { X } from 'lucide-react';
import { Section } from './Shared';
export const PainPoints = () => {
  const points = ['Dependés exclusivamente de las recomendaciones.', 'Publicás sin saber qué decir.', 'No sabés qué mostrar en redes.', 'Sentís que nadie interactúa con tu contenido.', 'Te cuesta transmitir confianza antes de la primera sesión.', 'No sabés cómo responder consultas por WhatsApp.', 'Tenés períodos con pocas consultas.', 'Sentís que otros terapeutas crecen más rápido que vos.', 'No lográs comunicar el valor real de tu trabajo.', 'Tu agenda depende demasiado de la suerte.'];
  return <Section className="max-w-4xl" data-id="element-362">
      <div className="text-center mb-12" data-id="element-363">
        <h2 className="text-2xl md:text-4xl lg:text-5xl font-display font-bold mb-6 leading-tight text-brand-darkGreen" data-id="element-364">
          ¿CUÁNTAS CONSULTAS MÁS VAS A PERDER POR NO MOSTRAR TU TRABAJO?
        </h2>
        <div className="text-brand-text mb-4 text-sm md:text-base max-w-2xl mx-auto space-y-4" data-id="element-365">
          <p data-id="element-366">
            Sos buen terapeuta. El problema no es tu formación ni tu
            experiencia. El problema es que nadie te enseñó a mostrar tu
            trabajo. Y mientras seguís dependiendo del boca a boca, muchas
            personas que necesitan tu ayuda nunca llegan a encontrarte.
          </p>
        </div>

        <p className="text-lg md:text-xl font-medium text-brand-error mt-6 font-serif italic" data-id="element-367">
          No te faltan conocimientos. Te falta visibilidad.
        </p>
      </div>

      <div className="glass-panel p-6 md:p-10 rounded-3xl mb-12 bg-white/70 border-brand-aqua/20" data-id="element-368">
        <h3 className="font-serif font-bold mb-6 flex items-center text-brand-darkGreen text-base md:text-lg" data-id="element-369">
          <X className="w-6 h-6 text-brand-error mr-2 shrink-0" data-id="element-370" /> LO QUE PASA
          CUANDO NO TENÉS VISIBILIDAD:
        </h3>
        <ul className="space-y-4" data-id="element-371">
          {points.map((point, i) => <li key={i} className="flex items-start" data-id="element-372">
              <X className="w-5 h-5 text-brand-error/80 mr-3 mt-0.5 shrink-0" data-id="element-373" />
              <span className="text-brand-text text-sm md:text-base" data-id="element-374">
                {point}
              </span>
            </li>)}
        </ul>
      </div>

      <div className="text-center" data-id="element-375">
        <h3 className="text-xl md:text-3xl font-display font-bold green-gradient-text" data-id="element-376">
          ¿Y SI ESTA FUERA LA ÚLTIMA VEZ QUE TRABAJÁS ASÍ?
        </h3>
      </div>
    </Section>;
};